import {useCallback, useMemo} from 'react';
import {usePortalPopoutManager} from './usePortalPopoutManager';
import type {
  PopoutOptions,
  PopoutTriggerRenderProps,
} from '../PortalPopoutReduxContext';

// ----------------------------
// usePortalPopout
// ----------------------------
export const usePortalPopout = (
  popoutId: string,
  options?: PopoutOptions
): PopoutTriggerRenderProps => {
  const {openPopout, closePopout, focusPopout, isPopoutOpen, getPopout} =
    usePortalPopoutManager();

  const isOpen = isPopoutOpen(popoutId);

  const popout = getPopout(popoutId);
  const isReady = popout?.isReady ?? false;
  // ---------------

  const open = useCallback(() => {
    openPopout(popoutId, options);
  }, [openPopout, popoutId, options]);
  // ---------------

  const close = useCallback(() => {
    closePopout(popoutId);
  }, [closePopout, popoutId]);
  // ---------------

  const toggle = useCallback(() => {
    if (isOpen) {
      close();
    } else {
      open();
    }
  }, [isOpen, open, close]);
  // ---------------

  const focus = useCallback(() => {
    focusPopout(popoutId);
  }, [focusPopout, popoutId]);
  // ---------------

  return useMemo(
    () => ({
      isOpen,
      isReady,
      open,
      close,
      toggle,
      focus,
    }),
    [isOpen, isReady, open, close, toggle, focus]
  );
};

export default usePortalPopout;
